/*************************************************/
/* GSAP ANIMATIONS                               */
/*************************************************/
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
import SplitText from 'gsap/SplitText';
import { anchorScroll } from './anchorScrollingWebsite';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
gsap.registerPlugin(SplitText)

export function gsapAnimations() {
    let mm = gsap.matchMedia();

    const init = () => {
        //Stuff for both report 2024 and website
        if (!document.body.classList.contains('report--2023')) {

            // Media fade
            var mediaElements = document.querySelectorAll('.animate--fade-media');

            if (mediaElements.length) {
                mediaElements.forEach(element => {
                    gsap.from(element, {
                        scrollTrigger: {
                            trigger: element,
                            start: "top 80%",
                            once: true,
                            scrub: false
                        },
                        duration: 0.5,
                        autoAlpha: 0, // Fade from invisible
                        stagger: 0.1
                    });
                });
            }
        }

        // Stuff only for report 2024
        if (document.body.classList.contains('report--2024')) {
            ScrollTrigger.defaults({
                ease: "none",
            });

            //Stuff we only want to animate on larger screens
            mm.add("(min-width:992px)", () => {
                //Video players and images
                const videosAndImages = [...document.querySelectorAll(".video-player--animate"), ...document.querySelectorAll(".image-item--animate")];
                if (videosAndImages) {
                    videosAndImages.forEach(element => {
                        gsap.from(element, {
                            scrollTrigger: {
                                trigger: element,
                                scrub: 1,
                                toggleActions: "play pause reverse pause",
                                start: "top center",
                                end: "center center",
                            },
                            width: "calc(100% - 260px)",

                            borderRadius: 15
                        });
                    })
                }
            });

            // Text lines fade
            var textElements = document.querySelectorAll('.animate--fade-text-lines');

            if (textElements.length) {
                textElements.forEach(element => {
                    let delay = element.classList.contains('media-content__overlay') ? .6 : 0; // Add delay if class is present

                    gsap.from(new SplitText(element, { type: 'lines' }).lines, {
                        scrollTrigger: {
                            trigger: element,
                            start: "top 80%",
                            once: true,
                            scrub: false
                        },
                        duration: 0.5,
                        autoAlpha: 0,
                        stagger: 0.1,
                        delay: delay // Apply delay
                    });
                });
            }

            // Text lines fade - HERO
            var textElements = document.querySelectorAll('.animate--fade-text-lines-hero');

            if (textElements) {
                textElements.forEach(element => {
                    let delayValue = window.innerWidth > 992 ? 2.4 : 0; // Apply delay only if above 992px

                    gsap.from(new SplitText(element, { type: 'lines' }).lines, {
                        scrollTrigger: {
                            trigger: element,
                            start: "top 80%",
                            once: true,
                            scrub: false
                        },
                        duration: 1.5,
                        delay: delayValue, // Dynamic delay based on screen width
                        autoAlpha: 0,
                        stagger: 0.1
                    });
                });
            }


            // Highlighted Boxes fade
            var textElements = document.querySelectorAll('.animate--fade-elements');

            if (textElements.length) {
                let timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: textElements[0], // Use the first element as the scroll trigger
                        start: "top 80%",
                        once: true, // Ensures it only runs once
                        scrub: false // Remove if you want a scrub effect
                    }
                });

                // Animate each box sequentially
                timeline.from(".animate--fade-elements", {
                    opacity: 0,
                    y: 50,
                    duration: 1,
                    stagger: 0.2 // Each element animates 0.5s apart
                });
            }

            //Breaker media
            const breakerMedias = document.querySelectorAll(".breaker__media");
            if (breakerMedias) {
                breakerMedias.forEach(breakerMedia => {
                    gsap.from(breakerMedia, {
                        scrollTrigger: {
                            trigger: breakerMedia,
                            scrub: 1,
                            start: "top center",
                            end: "center center",
                            toggleActions: "play pause reverse pause"
                        },
                        top: -110
                    })
                })
            }

            //Badges
            gsap.from('.image-item__badges img', {
                scrollTrigger: {
                    trigger: '.image-item__badges',
                    start: "top bottom",
                    once: true,
                    scrub: false
                },
                duration: 0.5,
                autoAlpha: 0,
                stagger: 0.5
            }
            )

        }

        // Stuff only for Website
        if (document.body.classList.contains('website')) {
            const smoother = ScrollSmoother.create({
                smooth: 0, // how long (in seconds) it takes to "catch up" to the native scroll position
                effects: true, // looks for data-speed and data-lag attributes on elements
                smoothTouch: 0.1, // much shorter smoothing time on touch devices
                wrapper: "#mainContent"
            });

            mm.add("(min-width:992px)", () => {
                const smoother = ScrollSmoother.create({
                    smooth: 2, // how long (in seconds) it takes to "catch up" to the native scroll position
                    effects: true, // looks for data-speed and data-lag attributes on elements
                    smoothTouch: 0.1, // much shorter smoothing time on touch devices
                    wrapper: "#mainContent"
                });

                //Image and video scale
                const imageAndVideoElements = [...document.querySelectorAll(".image-item"), ...document.querySelectorAll(".video-player")];
                imageAndVideoElements.forEach(element => {
                    gsap.from(element, {
                        scrollTrigger: {
                            trigger: element,
                            start: "top center",
                            end: "center center",
                            toggleActions: "play pause reverse pause",
                            scrub: 1,
                            scroller: "#mainContent",
                        },
                        scale: 0.85
                    })
                });
            });


            ScrollTrigger.defaults({
                ease: "none",
            });

            // Banners
            const websiteFontpageBannerMasks = document.querySelectorAll(".banner__media");
            if (websiteFontpageBannerMasks.length) {
                websiteFontpageBannerMasks.forEach(bannerMask => {

                    if (bannerMask.closest(".banner--size-full-width")) return false;

                    if (bannerMask.closest(".banner--size-frontpage")) {

                        ScrollTrigger.create({
                            trigger: bannerMask,
                            pin: bannerMask.querySelector('.banner__video-wrap'),
                            start: "top top",
                            end: "bottom top",
                            pinSpacing: false,
                        });
                    } else if (bannerMask.closest(".banner--size-subpage-single, .banner--size-case, .banner--size-insights, .banner--size-subpage-triple")) {
                        ScrollTrigger.create({
                            trigger: bannerMask,
                            pin: bannerMask.querySelector('.banner__image-wrap, video'),
                            start: "top top",
                            end: "bottom top",
                            pinSpacing: false,
                        });
                    } else if (bannerMask.closest(".banner--size-subpage")) {
                        ScrollTrigger.create({
                            trigger: bannerMask,
                            pin: bannerMask.querySelector('video, img'),
                            start: "top top",
                            end: "bottom top",
                            pinSpacing: false,
                        });
                    }
                });
            }

            // Text lines fade
            var textElements = document.querySelectorAll('.animate--fade-text-lines');

            if (textElements.length) {
                textElements.forEach(element => {
                    let delay = element.classList.contains('media-content__overlay') ? .6 : 0; // Add delay if class is present

                    gsap.fromTo(element,
                        {
                            opacity: 0,
                            y: 20
                        },
                        {
                            opacity: 1,
                            y: 0,
                            duration: 1,
                            ease: "power2.out",
                            delay: delay,
                            scrollTrigger: {
                                trigger: element,
                                start: "top bottom",
                                toggleActions: "play none none none",
                                once: true
                            }
                        }
                    );
                });
            }

            // Background transition on scroll
            const websiteBackgroundTransition = document.querySelectorAll(".animate--transition-background");
            const siteWrap = document.querySelector(".site-wrap__content");

            if (websiteBackgroundTransition.length && siteWrap) {
                websiteBackgroundTransition.forEach((element, index) => {
                    const startColor = element.dataset.startBackgroundColor;
                    const startTextColor = element.dataset.startTextColor?.toLowerCase().trim();
                    const endColor = element.dataset.backgroundColor;
                    const endTextColor = element.dataset.textColor?.toLowerCase().trim();

                    // Map text color hex to class name
                    const getThemeClass = (color) => {
                        if (color === "#ffffff") return "site-wrap__content--text-color-light";
                        if (color === "#000000") return "site-wrap__content--text-color-dark";
                        return ""; // fallback if unexpected value
                    };

                    const startThemeClass = getThemeClass(startTextColor);
                    const endThemeClass = getThemeClass(endTextColor);

                    // 🆕 Set initial background and text color if first element
                    if (index === 0) {
                        gsap.set(siteWrap, {
                            backgroundColor: startColor,
                            color: startTextColor
                        });
                        siteWrap.classList.add(startThemeClass);
                    }

                    // Get mask overlays (left and right)
                    const leftMask = element.querySelector('.mask-overlay.left');
                    const rightMask = element.querySelector('.mask-overlay.right');

                    const tl = gsap.timeline({
                        paused: true,
                        onStart: () => {
                            siteWrap.classList.remove("site-wrap__content--text-color-light", "site-wrap__content--text-color-dark");
                            siteWrap.classList.add(endThemeClass);
                        },
                        onReverseComplete: () => {
                            siteWrap.classList.remove("site-wrap__content--text-color-light", "site-wrap__content--text-color-dark");
                            siteWrap.classList.add(startThemeClass);
                            siteWrap.style.backgroundColor = startColor;
                        }
                    });
                    // Animate siteWrap background and text color, and mask overlays background
                    tl.to(siteWrap, {
                        backgroundColor: endColor,
                        color: endTextColor,
                        duration: 0.5,
                        ease: "power1.out"
                    });

                    // Animate the left and right masks' background color at the same time
                    if (leftMask && rightMask) {
                        tl.to(leftMask, {
                            backgroundColor: endColor,
                            duration: 0.5,
                            ease: "power1.out"
                        }, 0); // Make sure it happens at the same time as siteWrap
                        tl.to(rightMask, {
                            backgroundColor: endColor,
                            duration: 0.5,
                            ease: "power1.out"
                        }, 0); // Make sure it happens at the same time as siteWrap
                    }

                    ScrollTrigger.create({
                        trigger: element,
                        start: "top center",
                        end: "top center",
                        toggleActions: "play none reverse none",
                        animation: tl,
                        scroller: "#mainContent",
                    });

                });
            }

            let split;
            let tweens = [];
            const testimonialSliderText = document.querySelector('.testimonial-slide__text');

            // Reduce iOS Safari resize thrash
            ScrollTrigger.config({ ignoreMobileResize: true });

            if (testimonialSliderText) {
                function initTestimonialSliderText() {
                    // Kill old tweens/ScrollTriggers (prevents duplicates after rebuild)
                    if (tweens.length) {
                        tweens.forEach(t => {
                            t.scrollTrigger && t.scrollTrigger.kill();
                            t.kill();
                        });
                        tweens = [];
                    }

                    // Revert previous SplitText
                    if (split) {
                        split.revert();
                        split = null;
                    }

                    // Initialize SplitText
                    split = new SplitText(testimonialSliderText, { type: "lines" });

                    // GSAP animation for each line of text
                    split.lines.forEach((target, index) => {
                        const delay = index * 0.5;

                        // Build ScrollTrigger options; avoid scroller when ScrollSmoother is active
                        const stOpts = {
                            trigger: testimonialSliderText,
                            start: "top bottom",
                            toggleActions: "play none none none",
                            once: true
                        };

                        // Only use custom scroller if Smoother isn't active
                        if (!(window.ScrollSmoother && ScrollSmoother.get())) {
                            stOpts.scroller = "#mainContent";
                        }

                        const tween = gsap.to(target, {
                            backgroundPositionX: 0,
                            ease: "power1.out",
                            duration: 1,
                            delay,
                            scrollTrigger: stOpts
                        });

                        tweens.push(tween);
                    });
                }

                // Initialize on page load
                initTestimonialSliderText();
                ScrollTrigger.refresh();

                // Update on resize (debounced) — only if WIDTH changed
                let lastWidth = window.innerWidth;
                window.addEventListener('resize', debounce(() => {
                    const w = window.innerWidth;
                    if (w === lastWidth) return; // ignore height-only changes (iOS URL bar)
                    lastWidth = w;

                    initTestimonialSliderText(); // Re-initialize on real layout change
                    ScrollTrigger.refresh();
                }, 300)); // Adjust debounce time as necessary

                // Simple debounce function
                function debounce(func, wait) {
                    let timeout;
                    return function () {
                        clearTimeout(timeout);
                        timeout = setTimeout(func, wait);
                    };
                }
            }


            //Element/Content media
            const elementMedias = document.querySelectorAll(".element-content__cutout--two, .element-content__cutout--one");
            const isMobile = window.innerWidth < 992;
            if (elementMedias) {
                elementMedias.forEach(elementMedia => {
                    if (elementMedia.classList.contains('element-content__cutout--two')) {
                        const maskedElements = elementMedia.querySelectorAll('.image-cover-wrap, .video-item');
                        if (maskedElements && maskedElements.length == 2) {

                            ScrollTrigger.create({
                                trigger: elementMedia,
                                pin: maskedElements[0].querySelector('img, .video-item__player'),
                                start: "top top",
                                end: "bottom top",
                                pinSpacing: false,
                            }),

                                ScrollTrigger.create({
                                    trigger: elementMedia,
                                    pin: maskedElements[1].querySelector('img, .video-item__player'),
                                    start: "top top",
                                    end: "bottom top",
                                    pinSpacing: false,
                                }),

                                //Left
                                gsap.from(maskedElements[0], {
                                    scrollTrigger: {
                                        trigger: maskedElements[0],
                                        scrub: 2,
                                        start: "top center",
                                        end: "center top",
                                        toggleActions: "play pause reverse pause",
                                        scroller: "#mainContent",
                                    },
                                    top: isMobile ? '-150px' : '-300px'
                                });

                            //Right
                            gsap.from(maskedElements[1], {
                                scrollTrigger: {
                                    trigger: maskedElements[1],
                                    scrub: 1,
                                    start: "top center",
                                    end: "center top",
                                    toggleActions: "play pause reverse pause",
                                    scroller: "#mainContent",
                                },
                                top: isMobile ? '-50px' : '-140px'
                            });

                        }

                    } else {
                        const maskedElements = elementMedia.querySelectorAll(".image-cover-wrap, .video-item");
                        if (maskedElements) {
                            ScrollTrigger.create({
                                trigger: elementMedia,
                                pin: elementMedia.querySelector('img'),
                                start: "top top",
                                end: "bottom top",
                                pinSpacing: false,
                            }),
                                ScrollTrigger.create({
                                    trigger: elementMedia,
                                    pin: elementMedia.querySelector('.video-item__player'),
                                    start: "top top",
                                    end: "bottom top",
                                    pinSpacing: false,
                                });

                            gsap.from(maskedElements, {
                                scrollTrigger: {
                                    trigger: maskedElements,
                                    scrub: 1,
                                    start: "top center",
                                    end: "center top",
                                    toggleActions: "play pause reverse pause",
                                    scroller: "#mainContent",
                                },
                                top: isMobile ? '-50px' : '-140px',
                            });
                        }
                    }

                })
            }

            // Fade up effect
            gsap.utils.toArray('.fade-up').forEach((el) => {
                const img = el.querySelector('.image-cover-wrap');
                const video = el.querySelector('.video-item');
                const listItems = el.querySelectorAll('li');
                let bottomPosition = window.innerWidth > 992 ? 200 : 80;

                gsap.fromTo(el,
                    { y: bottomPosition },
                    {
                        y: 0,
                        duration: 1,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: el,
                            start: 'top bottom',
                            toggleActions: "play none none none",
                            once: true,
                            scroller: "#mainContent",
                        }
                    }
                );

                // Image: scale & opacity
                if (img) {
                    gsap.fromTo(img,
                        { scale: 1.25 },
                        {
                            scale: 1,
                            duration: 1,
                            ease: 'power2.out',
                            scrollTrigger: {
                                trigger: el, // Use the container as the trigger
                                start: 'top bottom',
                                toggleActions: "play none none none",
                                scroller: "#mainContent",
                                once: true
                            }
                        }
                    );
                    gsap.fromTo(img,
                        { opacity: 0 },
                        {
                            duration: .5,
                            opacity: 1,
                            ease: 'power2.out',
                            scrollTrigger: {
                                trigger: el, // Use the container as the trigger
                                start: 'top bottom',
                                toggleActions: "play none none none",
                                scroller: "#mainContent",
                                once: true
                            }
                        }
                    );
                }

                // List items: scale & opacity
                if (listItems) {
                    listItems.forEach(element => {
                        gsap.fromTo(element,
                            { opacity: 0 },
                            {
                                duration: .9,
                                opacity: 1,
                                ease: 'power2.out',
                                scrollTrigger: {
                                    trigger: el, // Use the container as the trigger
                                    start: 'top bottom',
                                    toggleActions: "play none none none",
                                    scroller: "#mainContent",
                                    once: true,
                                }
                            }
                        );
                    });
                }

                // Video: scale and opacity
                if (video) {
                    gsap.fromTo(video,
                        { scale: 1.25 },
                        {
                            scale: 1,
                            duration: 1,
                            ease: 'power2.out',
                            scrollTrigger: {
                                trigger: el, // Use the container as the trigger
                                start: 'top bottom',
                                toggleActions: "play none none none",
                                scroller: "#mainContent",
                                once: true
                            }
                        }
                    );
                    gsap.fromTo(video,
                        { opacity: 0 },
                        {
                            duration: .5,
                            opacity: 1,
                            ease: 'power2.out',
                            scrollTrigger: {
                                trigger: el, // Use the container as the trigger
                                start: 'top bottom',
                                toggleActions: "play none none none",
                                scroller: "#mainContent",
                                once: true
                            }
                        }
                    );
                }
            });

            ScrollTrigger.refresh();
            anchorScroll();
        }
    };

    init();
}

